import "./AddNewModalFooter.scss";
import { ReactNode } from "react";

type AddNewModalFooterProps = {
  children?: ReactNode;
};

export const AddNewModalFooter = ({ children }: AddNewModalFooterProps) => {
  return (
    <footer className="ui-add-new-modal-footer bg-white shadow ui-modal-footer">
      {children}
    </footer>
  );
};
